export class DOMVideo {
  video: HTMLVideoElement | HTMLAudioElement;

  constructor(video: HTMLVideoElement | HTMLAudioElement) {
    this.video = video;
  }

  setSrcObject(mediaStream: MediaStream) {
    this.video.addEventListener("loadedmetadata", (e) => {
      const video = e.target as HTMLVideoElement | HTMLAudioElement;
      if (video instanceof HTMLVideoElement) {
        // video.id
        // video.videoWidth
        // video.videoHeight
        // video.currentTime
        // video.readyState == video.HAVE_ENOUGH_DATA
      }
    });
    this.video.srcObject = mediaStream;
  }

  captureWebCamera() {
    navigator.mediaDevices
      .getUserMedia({
        video: true
      })
      .then((stream) => {
        this.setSrcObject(stream);
      });
  }

  // feature test for native video media switching media
  static async videoMediaChangeSupport() {
    return new Promise<boolean>((resolve) => {
      const iframe = document.createElement("iframe");
      const video = document.createElement("video");
      const source = document.createElement("source");
      const mediaSource = new MediaSource();
      mediaSource.addEventListener("sourceopen", () => resolve(true));
      source.src = URL.createObjectURL(mediaSource);
      source.media = "(min-width:10px)";
      video.append(source);
      iframe.width = "5";
      iframe.style.cssText = `position: absolute; visibility: hidden;`;
      document.documentElement.append(iframe);
      iframe.contentDocument?.body.append(video);
      setTimeout(() => {
        iframe.width = "15";
      });
      setTimeout(() => {
        iframe.remove();
        resolve(false);
      }, 1000);
    });
  }

  static tryAutoPlayOrAutoPlayAfterClick(
    video: HTMLVideoElement | HTMLAudioElement
  ) {
    return new Promise<boolean>((resolve) => {
      video
        .play()
        .then(() => {
          video.autoplay = true;
          resolve(true);
        })
        .catch(() => {
          DOMVideo.setAutoPlayWhenClick(video);
          resolve(false);
        });
    });
  }

  // 监听页面的点击事件，一旦点过了就能autoplay了
  static setAutoPlayWhenClick(video: HTMLVideoElement | HTMLAudioElement) {
    function setAutoPlay() {
      video.autoplay = true;
      video.play();
      document.removeEventListener("click", setAutoPlay);
      document.removeEventListener("touchend", setAutoPlay);
    }
    document.addEventListener("click", setAutoPlay);
    document.addEventListener("touchend", setAutoPlay);
  }
}

export default DOMVideo;
